import { useState, useEffect } from 'react';
import { trackEvent } from '../lib/tracking';
import { WHATSAPP_BASE } from '../lib/constants';
import { WHATSAPP_NUMBER } from '@/config/site';

interface MobileCtaBarProps {
  formAnchor?: string;
  whatsappMessage?: string;
  eventPrefix?: string;
}

export default function MobileCtaBar({
  formAnchor = 'qualificacao',
  whatsappMessage,
  eventPrefix = 'projetos',
}: MobileCtaBarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const waMsg = whatsappMessage
    ? encodeURIComponent(whatsappMessage)
    : encodeURIComponent(
        'Olá! Vim pelo site da Home Office Premium e gostaria de falar com um especialista sobre um projeto para minha empresa.'
      );

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9998] md:hidden transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white border-t border-background-200/60 px-4 py-3 flex gap-3">
        <a
          href={`#${formAnchor}`}
          onClick={() => trackEvent('form_start', { source: 'mobile_bar' })}
          className="flex-1 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-[14px] font-semibold py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          Solicitar projeto
        </a>
        <a
          href={`${WHATSAPP_BASE}?text=${waMsg}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent(`whatsapp_${eventPrefix}`, { location: 'mobile_bar' })}
          className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer flex-shrink-0"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
      </div>
    </div>
  );
}